export default __webpack_public_path__ + "static/media/PowerPoleWall_MK3.256.9e91f4a4.png";